import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';

import { CoreLink, LanguageSwitcher } from '@uncinc/react-drupal-core';
import { Container, NavigationScroll } from '@uncinc/uncinc-react-kitchen-sink';

import {
  MenuMainOverlay,
  MenuSecondary,
} from '../../../implementations';
import { ReactComponent as LogoSVG } from '../../../assets/images/amsterdamunderground-logo.svg';

import './style.scss';

const AmsterdamundergroundHeader = () => {
  const [loaded, setLoaded] = useState(false);
  const [overlayMenuVisible, setOverlayMenuVisible] = useState(false);
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  window.addEventListener('load', () => {
    setLoaded(true);
  });

  useEffect(() => {
    document.body.classList.toggle('Header__overlay--body', overlayMenuVisible);
  }, [overlayMenuVisible]);

  const classes = c({
    expanded: overlayMenuVisible,
    preload: !loaded,
  });

  return (
    <NavigationScroll>
      <header className={classes}>
        <Container className="Header__container">
          <div className="row">
            <div className="Header__logo col-2">
              <CoreLink
                href={currentLanguage === 'nl' ? '/' : `/${currentLanguage}`}
                onClick={() => setOverlayMenuVisible(false)}
              >
                <div className="Header__logo__img" alt="De Regenboog Groep logo">
                  <LogoSVG />
                </div>
              </CoreLink>
            </div>
            <div className="Header col-10">
              <div className="Header__menu">
                <div className="Header__menu__secondary">
                  <MenuSecondary setOverlayMenuVisible={setOverlayMenuVisible} id="amsterdamunderground-main-cta" />
                </div>
              </div>
              <div className="Header__language_switcher">
                <LanguageSwitcher hideActive={false} />
              </div>
              <div className="Header__buttons">
                <i
                  onClick={() => {
                    setOverlayMenuVisible(!overlayMenuVisible);
                  }}
                  className={`icon icon-${overlayMenuVisible ? 'cross' : 'hamburger'}`} />
              </div>
            </div>
          </div>
        </Container>
        <div className="Header__overlay">
          <Container>
            <div className="row">
              <div className="col-12 Header__overlay__main_menu order-2 order-lg-1">
                <MenuMainOverlay
                  onClick={() => setOverlayMenuVisible((prevMenuActive) => !prevMenuActive)}
                  setOverlayMenuVisible={setOverlayMenuVisible}
                  when={overlayMenuVisible}
                />
              </div>
            </div>
          </Container>
        </div>
      </header>
    </NavigationScroll>
  );
};

export default AmsterdamundergroundHeader;
